import React from 'react';
import styled from 'styled-components';
import { Ireland, Toolbox, Rulers } from 'assets/svgs/';

function ThreePoints() {
  return (
    <Container className="fade-in">
      <Point>
        <Ireland width="61px" />
        <h2>
          Irish Owned
          <br />
          Family Business
        </h2>
        <p>Supplying quality, handcrafted products across Ireland since 2002.</p>
      </Point>
      <Point>
        <Toolbox width="52px" />
        <h2>
          Expert Advise
          <br />
          And Design Service
        </h2>
        <p>
          We offer free consultations and callouts to help you choose the perfect product for your
          home.
        </p>
      </Point>
      <Point>
        <Rulers width="55px" style={{ position: 'relative', bottom: '4px' }} />
        <h2>
          Superior Craftsmanship,
          <br />
          Unparalled Quality
        </h2>
        <p>
          Meticulously crafted by skilled artisans using only the finest materials and techniques.
        </p>
      </Point>
    </Container>
  );
}

const Container = styled.ul`
  background-color: #fff;
  border-radius: 6px;
  display: grid;
  gap: 10px 20px;
  grid-column: 1/13;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  justify-content: center;
  justify-items: center;
  list-style: none;
  margin: -137px auto 0;
  max-width: 490px;
  padding: 40px 12px;
  text-align: center;
  width: 100%;
  z-index: 1;

  @media (width >= 390px) {
    padding: 40px 1.5rem;
  }

  @media (width >= 768px) {
    max-width: unset;
    grid-column: 2/12;

    > li:last-of-type {
      position: relative;
      left: calc(50% + 10px);
    }
  }

  @media (width >= 1030px) {
    > li:last-of-type {
      position: initial;
      left: initial;
    }
  }

  @media (width >= 1127px) {
    padding: 40px 1.5rem;
    row-gap: initial;
  }

  @media (width >= 1200px) {
    padding: 40px 1.25rem;
  }

  @media (width >= 1360px) {
    padding: 61px 58px;
  }
`;

const Point = styled.li`
  display: grid;
  grid-row: span 3;
  grid-template-rows: subgrid;
  justify-items: center;
  max-width: 312px;
  width: 100%;

  @media (width <= 1126px) {
    &:not(:last-of-type) {
      margin-bottom: 34px;
    }
  }

  svg {
    margin-bottom: 0.8rem;
  }

  h2 {
    font-size: 1.125rem;
    line-height: 1.4em;
    text-transform: uppercase;

    @media (width >= 1127px) {
      margin-bottom: 0.4em;
    }
  }

  p {
    font-size: 1rem;
  }
`;

export default ThreePoints;
